import React, { useEffect, useState } from "react";
import { CreateOutlined, ChecklistRtlOutlined, ShoppingBagOutlined, EditNoteOutlined } from '@mui/icons-material';
import { Box, Typography } from '@mui/material';
import { Footer, Tabs } from '../../components';

const TabsSales = ({
  onTabSelected,
  tabSelected = 0,
  colorBackground = '#F4DDDB',
  options = [],
  positionTab = 'bottom',
  width = '100vw',
  colorTabs = '#F6EDE1'
}) => {
  const [optionFooter, setOptionFooter] = useState(tabSelected);
  const footerHeight = 64

  const handleOptionFooter = (value) => {
    console.log(value)
    setOptionFooter(value)
    onTabSelected && onTabSelected(value)
  }

  useEffect(() => {
    setOptionFooter(tabSelected)
  }, [tabSelected])

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', position: 'relative', width: width, height: '100%', minHeight: 0 }}>
      {positionTab === 'top' && <Footer defaultOption={optionFooter} options={options} onOptionSelected={handleOptionFooter} backgroundColor={colorTabs}/>}
      <Box
        display='flex'
        flexDirection='column'
        flex='1'
        sx={{
          position: 'relative',
          width: '100%',
          background: colorBackground,
          pb: positionTab === 'bottom' ? `${footerHeight}px` : 0,
          minHeight: 0,
          overflowY: 'auto',
        }}
      >
        {options[optionFooter].Content()}
      </Box>
      {positionTab === 'bottom' && (
        <Box
          sx={{
            position: 'fixed',
            left: 0,
            right: 0,
            bottom: 0,
            zIndex: 1200,
            boxShadow: '0 -8px 20px rgba(0,0,0,0.12)',
          }}
        >
          <Footer defaultOption={optionFooter} options={options} onOptionSelected={handleOptionFooter} backgroundColor={colorTabs}/>
        </Box>
      )}
    </Box>
  )
}

export default TabsSales;